// Dutch

export default {
  newVersionAvailable: 'Nieuwe versie beschikbaar',
  versionInfo: 'Er is een nieuwe versie van {appName} beschikbaar. Herlaad de pagina om de nieuwe versie {version} te gebruiken.',
  reload: 'Herlaad',
  later: 'Later',
};
